import React, { Component } from 'react'
import Modal from 'react-modal'
import RestApiUtils from '../../../../apiclient/moebli/RestApiUtils'
import PenaltyModalUI from './PenaltyModalUI.js'

class PenaltyModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      submitted: false,
      defaultInterest: '',
      defaultInterestError: null
    }
  }

  render() {
    return (
      <PenaltyModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // modes
        updateMode={this.props.updateMode}
        submitted={this.state.submitted}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.onCancelClick}
        // form fields
        defaultInterest={this.state.defaultInterest}
        onDefaultInterestChange={(event) => { this.setState({ defaultInterest: event.target.value }) }}
        defaultInterestError={this.state.defaultInterestError}
        setDefaultInterestError={(error) => { this.setState({ defaultInterestError: error }) }}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    Modal.setAppElement('body')
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.post(this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/repayments/scheduledDates/${this.props.selectedScheduledDate}/defaultPenalties/partialPayments`,
      this.onSubmitCallback, {
      defaultInterestF: this.state.defaultInterest,
    }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onCancelClick()
        this.props.onRefreshClick()
      }, 1000)
    }
  }

  onCancelClick = () => {
    this.setState({
      errorList: null,
      submitted: false,
    })
    this.props.onCancelClick()
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default PenaltyModalSF
